import { InvoiceSearchCriteria } from "./InvoiceSearchCriteria";

export interface SupplierInvoiceSearchCriteria extends InvoiceSearchCriteria{
  locationId?: string,
}

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const SUPPLIER_INVOICES_DATE_BYPASS_KEYS: readonly (keyof SupplierInvoiceSearchCriteria)[] = ['bookingNumber', 'invoiceNumber'];
